import {
    Bike,
    Phone,
    MapPin,
    Clock3,
    ShieldCheck,
    Route,
    Package,
    Navigation,
} from "lucide-react";

import "./DeliveryTab.css";

function DeliveryTab({ order }) {

    const delivery = order.deliverySnapshot || {};
    const address = order.addressSnapshot || {};

    return (

        <div className="delivery-tab">

            {/* ================= DELIVERY PARTNER ================= */}

            <div className="delivery-profile-card">

                <div className="delivery-avatar">

                    <Bike size={38} />

                </div>

                <div className="delivery-profile-info">

                    <h2>

                        {delivery.name || "Delivery Partner Not Assigned"}

                    </h2>

                    <p>

                        HomeFoods Delivery Partner

                    </p>

                </div>

            </div>

            {/* ================= PARTNER INFO ================= */}

            <div className="delivery-info-grid">

                <div className="delivery-info-card">

                    <Phone size={20} />

                    <div>

                        <label>Phone Number</label>

                        <h4>

                            {delivery.phone || "-"}

                        </h4>

                    </div>

                </div>

                <div className="delivery-info-card">

                    <Bike size={20} />

                    <div>

                        <label>Vehicle Number</label>

                        <h4>

                            {delivery.vehicleNumber || "-"}

                        </h4>

                    </div>

                </div>

                <div className="delivery-info-card">

                    <ShieldCheck size={20} />

                    <div>

                        <label>Delivery Status</label>

                        <h4>

                            {order.deliveryStatus || "Waiting"}

                        </h4>

                    </div>

                </div>

                <div className="delivery-info-card">

                    <Navigation size={20} />

                    <div>

                        <label>OTP Verification</label>

                        <h4>

                            {order.otpVerified ? "Verified" : "Pending"}

                        </h4>

                    </div>

                </div>

            </div>

            {/* ================= DELIVERY ADDRESS ================= */}

            <div className="delivery-address-card">

                <div className="delivery-card-title">

                    <MapPin size={20} />

                    <h3>

                        Delivery Destination

                    </h3>

                </div>

                <div className="delivery-address-box">

                    <strong>

                        {address.fullName || "-"}

                    </strong>

                    <p>

                        {address.phone}

                    </p>

                    <p>

                        {address.addressLine1}

                    </p>

                    {

                        address.addressLine2 &&

                        <p>

                            {address.addressLine2}

                        </p>

                    }

                    {

                        address.landmark &&

                        <p>

                            Landmark : {address.landmark}

                        </p>

                    }

                    <p>

                        {address.city},

                        {" "}

                        {address.state}

                        {" - "}

                        {address.pincode}

                    </p>

                </div>

            </div>

            {/* ================= DELIVERY STATS ================= */}

            <div className="delivery-stats-grid">

                <div className="delivery-stat-card">

                    <Clock3 size={22} />

                    <div>

                        <span>

                            Estimated Time

                        </span>

                        <h3>

                            {address.estimatedDeliveryTime || 0}

                            {" "}Min

                        </h3>

                    </div>

                </div>

                <div className="delivery-stat-card">

                    <Route size={22} />

                    <div>

                        <span>

                            Delivery OTP

                        </span>

                        <h3>

                            {order.deliveryOTP || "----"}

                        </h3>

                    </div>

                </div>

                <div className="delivery-stat-card">

                    <Package size={22} />

                    <div>

                        <span>

                            Delivery Stage

                        </span>

                        <h3>

                            {order.deliveryStatus}

                        </h3>

                    </div>

                </div>

                <div className="delivery-stat-card">

                    <Bike size={22} />

                    <div>

                        <span>

                            Partner Assigned

                        </span>

                        <h3>

                            {delivery.name ? "Yes" : "No"}

                        </h3>

                    </div>

                </div>

            </div>

            {/* ================= LIVE TRACKING ================= */}

            <div className="tracking-card">

                <div className="delivery-card-title">

                    <Navigation size={20}/>

                    <h3>

                        Live Tracking

                    </h3>

                </div>

                <div className="tracking-placeholder">

                    Live GPS tracking, rider movement, ETA updates and route history will appear here after integrating Google Maps and live socket tracking.

                </div>

            </div>

        </div>

    );

}

export default DeliveryTab;